import { useEffect } from "react";

const PATHNAME_START_INDEX = 2;
const OLD_REACT_PAGES_PREFIX = "/l";

/**
 * Removes the old "l" prefix from the path and redirects to the correct url.
 */
const useRemoveOldPrefixFromPath = () => {
  useEffect(() => {
    if (window.location.pathname.startsWith(OLD_REACT_PAGES_PREFIX)) {
      const sanitizedPath =
        window.location.pathname.slice(PATHNAME_START_INDEX);

      window.location.href = window.location.href.replace(
        window.location.pathname,
        sanitizedPath
      );
    }
  }, []);
};

export default useRemoveOldPrefixFromPath;
